export enum Status {
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
  ERROR = 'error',
  NEUTRAL = 'neutral',
}
